import { v4 as uuidv4 } from "uuid";

const componentTemplate = {
  description: {
    name: "description",
    label: "Description",
    value: [
      {
        name: "description",
        label: "Text",
        languages: {
          en: "Here comes the description.",
        },
      },
    ],
    backgroundColor: "#ffffff",
    fontColor: "#000000",
    fontSize: 16,
    lineHeight: 20,
    dividerColor: "#000000",
    dividerSize: 0,
    alignItems: "center",
    gapTop: 15,
    gapBottom: 15,
    gapLeft: 15,
    gapRight: 15,
    bold: false,
    displayDefault: true,
    displaySuccess: false,
    displayError: false,
    startFooter: false,
  },
  image: {
    name: "image",
    label: "Image",
    value: [
      {
        name: "image",
        label: "Image",
        languages: {
          en: "https://codikett.ams3.digitaloceanspaces.com/securikett/logo/sec_signet.PNG",
        },
      },
    ],
    backgroundColor: "#ffffff",
    dividerColor: "#000000",
    dividerSize: 0,
    alignItems: "center",
    gapTop: 15,
    gapBottom: 15,
    gapLeft: 15,
    gapRight: 15,
    imgWidth: 30,
    displayDefault: true,
    displaySuccess: false,
    displayError: false,
    startFooter: false,
  },
  gallery: {
    name: "gallery",
    label: "Gallery",
    value: [
      {
        name: "gallery",
        label: "Image URL",
        languages: {
          en: "https://codikett.ams3.digitaloceanspaces.com/securikett/logo/sec_signet.PNG",
        },
      },
      {
        name: "gallery",
        label: "Image URL",
        languages: {
          en: "https://codikett.ams3.digitaloceanspaces.com/securikett/logo/codikett.png",
        },
      },
    ],
    backgroundColor: "#ffffff",
    dividerColor: "#000000",
    dividerSize: 0,
    alignItems: "center",
    gapTop: 15,
    gapBottom: 15,
    gapLeft: 15,
    gapRight: 15,
    imgWidth: 30,
    displayDefault: true,
    displaySuccess: false,
    displayError: false,
    startFooter: false,
  },
  video: {
    name: "video",
    label: "Video",
    autoplayButton: false,
    value: [
      {
        name: "video",
        label: "Video",
        languages: {
          en: "https://codikett.ams3.digitaloceanspaces.com/securikett/navigator/videos/Inspector-4.m4v",
        },
      },
      {
        name: "redirectFromVideo",
        label: "Redirect after Video",
        languages: {
          en: "",
        }
      },

    ],
    backgroundColor: "#ffffff",
    dividerColor: "#000000",
    dividerSize: 0,
    alignItems: "center",
    gapTop: 15,
    gapBottom: 15,
    gapLeft: 15,
    gapRight: 15,
    displayDefault: true,
    displaySuccess: false,
    displayError: false,
    startFooter: false,
  },
  verificationSuccessful: {
    name: "verificationSuccessful",
    label: "Verification successful",
    img: "https://codikett.ams3.digitaloceanspaces.com/securikett/icon/icon-checked.svg",
    value: [
      {
        name: "verificationSuccessful",
        label: "Text",
        languages: {
          en: "CODE VERIFICATION SUCCESSFUL!",
        },
      },
    ],
    backgroundColor: "#ffffff",
    fontColor: "#000000",
    fontSize: 20,
    dividerColor: "#000000",
    dividerSize: 0,
    alignItems: "center",
    gapTop: 15,
    gapBottom: 15,
    gapLeft: 15,
    gapRight: 15,
    displayDefault: true,
    displaySuccess: false,
    displayError: false,
    startFooter: false,
  },
  pin: {
    name: "pin",
    label: "PIN",
    backgroundColor: "#ffffff",
    buttonColor: "#1976d2",
    dividerColor: "#000000",
    dividerSize: 0,
    alignItems: "center",
    buttonTextAlignment: "center",
    retries: 3,
    enableButton: true,
    checkInstantly: false,
    showTop: true,
    buttonLeftRound: false,
    buttonRightRound: true,
    value: [
      {
        name: "errorMessageRetry",
        label: "Message Retry",
        languages: {
          en: "You entered the wrong pin number. Please try again.",
        },
      },
      {
        name: "inputPlaceholder",
        label: "Placeholder",
        languages: {
          en: "→ Enter your code here",
        },
      },
      {
        name: "buttonText",
        label: "Button Text",
        languages: {
          en: "Submit",
        },
      },
      {
        name: "redirect",
        label: "Redirect URL",
        languages: {
          en: "",
        },
      },
    ],
    gapTop: 15,
    gapBottom: 15,
    gapLeft: 15,
    gapRight: 15,
    inputSize: 50,
    startFooter: false,
  },
  redirect: {
    name: "redirect",
    label: "Redirect",
    value: [
      {
        name: "redirect",
        label: "Redirect URL",
        languages: {
          en: "https://www.securikett.com",
        },
      },
    ],
  },
  button: {
    name: "button",
    label: "Button",
    backgroundColor: "#ffffff",
    dividerColor: "#000000",
    dividerSize: 0,
    alignItems: "center",
    value: [
      {
        name: "button",
        label: "Text",
        languages: {
          en: "Button",
        },
      },
      {
        name: "redirect",
        label: "Redirect URL",
        languages: {
          en: "",
        },
      },
    ],
    gapTop: 15,
    gapBottom: 15,
    gapLeft: 15,
    gapRight: 15,
    fontSize: 14,
    buttonColor: "#1976d2",
    displayDefault: true,
    displaySuccess: false,
    displayError: false,
    startFooter: false,
  },
  noscript: {
    name: "noscript",
    label: "No Javascript",
    value: [
      {
        name: "noscript",
        label: "No Javascript",
        languages: {
          en: "please activate javascript to be able to use this site without restrictions",
        },
      },
    ],
  },
  slotmachine: {
    name: "slotmachine",
    label: "Slot Machine",
    slotCount: 1,
    recipientEmail:"test@emailprovider.com",
    bodyText:"Text to add to the body",
//    subjectText:"Put in your Subject for Email",
    //subjectText falls man es unten hier als value added geht 
    //subject in der echten email funktion verloren wenn man auf email klickt

    value: [
      {
        name: "image",
        label: "Image URL",
        languages: {
          en: "https://codikett.ams3.digitaloceanspaces.com/securikett/bandit/002.png",
        },
      },
      {
        name: "image",
        label: "Image URL",
        languages: {
          en: "https://codikett.ams3.digitaloceanspaces.com/securikett/bandit/001.png",
        },
      },
      {
        name: "subjectText",
        label: "Subject Text",
        languages: {
          en: "Put in your Subject for Email",
        },
      },
     

    ],
    gapTop: 15,
    gapBottom: 15,
    gapLeft: 15,
    gapRight: 15,
    fontSize: 14,
    buttonColor: "#1976d2",
    displayDefault: true,
    displaySuccess: false,
    displayError: false,
    startFooter: false,
  },


};


const templatenew = {
  pagename: "",
  pagenamecap: "",
  reactConfig: {
    color: {
      font: {
        id: "font",
        label: "Font color",
        value: "#000000",
      },
      background: {
        id: "background",
        label: "Background color",
        value: "#ffffff",
      },
    },
    gaps: {
      gapTop: {
        id: "gapTop",
        label: "Spacing top",
        value: 15,
      },
      gapBottom: {
        id: "gapBottom",
        label: "Spacing bottom",
        value: 15,
      },
      gapLeft: {
        id: "gapLeft",
        label: "Spacing left",
        value: 15,
      },
      gapRight: {
        id: "gapRight",
        label: "Spacing right",
        value: 15,
      },
    },
    components: [
      {
        ...componentTemplate.image,
        value: [
          {
            name: "image",
            label: "Image",
            languages: {
              en: "https://codikett.ams3.digitaloceanspaces.com/securikett/logo/codikett.png",
            },
          },
        ],
        id: uuidv4(),
      },
      {
        ...componentTemplate.description,
        id: uuidv4(),
        value: [
          {
            name: "description",
            label: "Text",
            languages: {
              en: "TITLE",
            },
          },
        ],
        fontSize: 32,
      },
      {
        ...componentTemplate.description,
        id: uuidv4(),
      },
      {
        ...componentTemplate.image,
        id: uuidv4(),
      },
      {
        ...componentTemplate.description,
        id: uuidv4(),
      },
      {
        ...componentTemplate.verificationSuccessful,
        id: uuidv4(),
      },
    ],
  },
  pageDescriptionList: [
    {
      language: "en",
      htmlcode: "",
      isDefault: true,
    },
  ],
};

const verificationListRows = [
  { id: 1, time: "02.07.2020 16:39:56", country: "DE", city: "Hamburg" },
  { id: 2, time: "01.07.2020 10:34:05", country: "AT", city: "Wien" },
  { id: 3, time: "01.07.2020 09:12:21", country: "AT", city: "Graz" },
];

const sliderElements = [
  {
    name: "imgWidth",
    label: "Image size:",
    minValue: 1,
    maxValue: 100,
    defaultValue: 30,
  },
  {
    name: "fontSize",
    label: "Font size:",
    minValue: 8,
    maxValue: 64,
    defaultValue: 16,
  },
  {
    name: "lineHeight",
    label: "lineHeight:",
    minValue: 1,
    maxValue: 50,
    defaultValue: 20,
  },
  {
    name: "gapTop",
    label: "Spacing top:",
    minValue: 0,
    maxValue: 100,
    defaultValue: 15,
  },
  {
    name: "gapBottom",
    label: "Spacing bottom:",
    minValue: 0,
    maxValue: 100,
    defaultValue: 15,
  },
  {
    name: "gapLeft",
    label: "Spacing left:",
    minValue: 0,
    maxValue: 100,
    defaultValue: 15,
  },
  {
    name: "gapRight",
    label: "Spacing right:",
    minValue: 0,
    maxValue: 100,
    defaultValue: 15,
  },
  {
    name: "dividerSize",
    label: "Divider size:",
    minValue: 0,
    maxValue: 10,
    defaultValue: 0,
  },
  {
    name: "inputSize",
    label: "Input width:",
    minValue: 0,
    maxValue: 100,
    defaultValue: 100,
  },
];

const aligmnentElements = [
  {
    name: "alignItems",
    label: "Aligment:",
  },
  {
    name: "buttonTextAlignment",
    label: "Alignment (Button):",
  },
];

const colorElements = [
  {
    name: "fontColor",
    label: "Font color:",
  },
  {
    name: "backgroundColor",
    label: "Background color:",
  },
  {
    name: "buttonColor",
    label: "Button color:",
  },
  {
    name: "dividerColor",
    label: "Divider color:",
  },
];

const switchElements = [
  {
    name: "showTop",
    label: "Show components above PIN after successful pin entry?",
  },
  {
    name: "enableButton",
    label: "Button enabled?",
  },
  {
    name: "autoplayButton",
    label: "Autoplay",
  },
  {
    name: "checkInstantly",
    label: "Check PIN instantly",
    disabledIfNot: "enableButton",
  },
  {
    name: "buttonLeftRound",
    label: "Button rounded (left)",
  },
  {
    name: "buttonRightRound",
    label: "Button rounded (right)",
  },
  {
    name: "bold",
    label: "Bold",
  },
  {
    name: "displayDefault",
    label: "Display (before pin)",
  },
  {
    name: "displaySuccess",
    label: "Display (after pin success)",
  },
  {
    name: "displayError",
    label: "Display (after pin error)",
  },
  {
    name: "startFooter",
    label: "Start footer",
  },
];

const steps = [
  {
    selector: '[data-tour="rpdesigner-step-1"]',
    content:
      'Here you can change the different font-options for the "Response Page"',
  },
  {
    selector: '[data-tour="rpdesigner-step-2"]',
    content:
      'Here you can add/remove various component-options for the "Response Page"',
  },
  {
    selector: '[data-tour="rpdesigner-step-3"]',
    content: "You can click on a selected component to change its value",
  },
];

const rpScript = `
var retries = 2;
//let uri = "https://vdev.codikett.com/resources/pin/";

setTimeout(function () {
  const rp = document.querySelector("#responsepagePreview");

  try {
    var autoplayButton = rp.querySelector('#autoplayButton');
    if ((rp.querySelector("#video") != null) && (autoplayButton.value === "true")) {
      function playVideo() {
        var video = rp.querySelector('#video');
        video.play();
      }
      playVideo();
    }
  } catch (e) {
    console.log("Error:", e);
  }

  try {
    var video = rp.querySelector('#video');
    var targetUrl = rp.querySelector('#redirectFromVideo').value;
    if(video !== null && targetUrl !== undefined && targetUrl !== null && targetUrl.trim() !== ""){
      video.addEventListener('ended', function () {
        if (targetUrl.trim() !== '') {
          window.open(targetUrl, '_blank');
        }
      });
    }
  } catch (e) {
    console.log("Error:", e);
  }

  try {
    const slidesWrappers = rp.querySelectorAll(".slider-wrapper");
    for (var i = 0; i < slidesWrappers.length; i++) {
      const slidesWrapper = slidesWrappers[i];
      const slidesContainer = slidesWrapper.querySelector("#slides-container");
      const slide = slidesWrapper.querySelector(".slide");
      const prevButton = slidesWrapper.querySelector("#slide-arrow-prev");
      const nextButton = slidesWrapper.querySelector("#slide-arrow-next");

      nextButton.addEventListener("click", () => {
        const slideWidth = slide.clientWidth;
        slidesContainer.scrollLeft += slideWidth;
      });

      prevButton.addEventListener("click", () => {
        const slideWidth = slide.clientWidth;
        slidesContainer.scrollLeft -= slideWidth;
      });
    }
  } catch (e) {
    console.log("swiper error:" + e.message);
  }

  try {
    var buttons = rp.querySelectorAll('[id^="redirectbutton_"]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener("click", function (e) {
        window.open(e.target.nextElementSibling.innerText);
      });
    }
  } catch (e) { }

  try {
    if (rp.querySelector("#errorMessageRetry") != null)
      rp.querySelector("#errorMessageRetry").style.display = "none";

    checkDisplayComponents(rp, 0);
  } catch (e) {}

  try {
    if (rp.querySelector("#pinbutton") != null) {
      retries = parseInt(rp.querySelector("#retries").textContent);
      if (isNaN(retries)) {
        retries = 1;
      }

      var enableButton = rp.querySelector("#enableButton").value;
      var checkInstantly = rp.querySelector("#checkInstantly").value;

      if (enableButton === "false" || checkInstantly === "true") {
        rp.querySelector("#pin").addEventListener("input", function (e) {
          const val = e.target.value;
          if (val.length >= 5) {
            checkPin(val, rp);
          } else {
            rp.querySelector("#errorMessageRetry").style.display = "none";
          }
        });
      }
      if (enableButton === "true" || checkInstantly === "true") {
        rp.querySelector("#pinbutton").addEventListener("click", function (e) {
          var pin = rp.querySelector("#pin").value;
          checkPin(pin, rp);
        });
      }
    }
  } catch (e) {}

  try {
    if (rp.querySelector("#spinbutton") != null) {
      const spinButton = rp.querySelector("#spinbutton");
      let winMsg = rp.querySelector("#winMessage");
      let rollAnimation;
      let animationHasPlayed = false;

      const imgElement = rp.querySelector("#img" + i);
      const placeHolder = rp.querySelector("#placeholderImage");

      const claimPrizeOnce = () => {
        claimPrize();
        clearInterval(rollAnimation);

        spinButton.removeEventListener("click", claimPrizeOnce);
      };

      spinButton.addEventListener("click", () => {
       
        if (!animationHasPlayed) { 
          
          animationHasPlayed = true;
          placeHolder.style.display = 'none';
          imgElement.style.display = 'block';
          spinButton.style.visibility = "collapse";
          
          let maxId = findMaxId(rp);
          // If no matching inputs found, don't proceed further
          if (maxId === -1) {
            return;
          }

          // Set the number of rolls
          const numberOfSlots = parseInt(rp.querySelector("#slotcount").value, 10);

          const animationSpeed = 150;

          // Set the target symbol for the animation
          let targetSymbol = rp.querySelector("#img0").src;

          const rollAnimation = setInterval(() => {
            for (let i = 0; i < numberOfSlots; i++) {
              // Create a random number between 0 and maxId
              let randomId = Math.floor(Math.random() * (maxId + 1));

              // Get the corresponding input element
              let inputElement = rp.querySelector("#spinimage" + randomId);

              // Get the image element
              

              // If both elements exist, set the image value to a random symbol
              if (inputElement && imgElement) {
                // Temporarily display random symbols during the roll animation
                let randomSymbol = inputElement.value;
                imgElement.src = randomSymbol;

                // Move the image element from top to bottom using CSS transition
                imgElement.style.transition = "top " + animationSpeed + "ms ease-out";
                imgElement.style.top = -i * imgElement.clientHeight + "px";
              }
            }

          }, animationSpeed * numberOfSlots);

          setTimeout(() => {
            clearInterval(rollAnimation);

            // Set all symbols to the target symbol at the end of the animation
            for (let i = 0; i < numberOfSlots; i++) {
              let imgElement = rp.querySelector("#img" + i);
              imgElement.src = targetSymbol;
              imgElement.style.top = 0; // Reset the top position to its original position
            }

            // Check win condition
            let allSymbolsMatch = true;
            for (let i = 0; i < numberOfSlots; i++) {
              let imgElement = rp.querySelector("#img" + i);
              if (imgElement.src !== targetSymbol) {
                allSymbolsMatch = false;
                break;
              }
            }

            // Show win message if all symbols match the target symbol
            if (allSymbolsMatch) {
              winMsg.style.display = "inherit";
              // Change the button text and link it to claimPrize function
              spinButton.style.visibility = "visible";
              spinButton.innerText = "Claim your Prize";
              spinButton.removeEventListener("click", claimPrize);
            }
            spinButton.addEventListener("click", claimPrizeOnce);
            spinButton.disabled = false;
          }, animationSpeed * numberOfSlots * 20);
        } else {
          claimPrizeOnce();
        }
      });
    }
  } catch (e) { }

  function claimPrize() {
    const recipientEmail = rp.querySelector("#recipientEmail").value;
    const bodyText = rp.querySelector("#bodyText").value;
    const subjectText = rp.querySelector("#subjectText").value;
    const encodedBodyText = bodyText.replace(/"/g, '\\"');
    const encodedSubjectText = subjectText.replace(/"/g, '\\"');
    const mailtoLink = "mailto:" + recipientEmail + "?subject=" + encodedSubjectText + "&body=" + encodedBodyText;
    window.open(mailtoLink, "_blank");
  }

}, 100);

/*
 * status:
 *  - 0 ... default
 *  - 1 ... success
 *  - 2 ... error
 */



function checkDisplayComponents(rp, status) {
  var components = rp.querySelectorAll("div[name='reactComponent']");
  var beforePin = true;
  components.forEach((c) => {
    var displayDefault =
      c.querySelector("#displayDefault") !== null
        ? c.querySelector("#displayDefault").value
        : undefined;
    var displaySuccess =
      c.querySelector("#displaySuccess") !== null
        ? c.querySelector("#displaySuccess").value
        : undefined;
    var displayError =
      c.querySelector("#displayError") !== null
        ? c.querySelector("#displayError").value
        : undefined;

    if (
      (status === 0 && displayDefault === "false") ||
      (status === 1 && displaySuccess === "false") ||
      (status === 2 && displayError === "false")
    ) {
      c.style.display = "none";
    } else {
      c.style.display = "inherit";
    }

    if (c.id === "pinComponent" && status !== 0) {
      beforePin = false;
      c.style.display = "none";
    }
  });
}

function checkPin(pin, rp) {
  var pinControl = rp.querySelector("#pinControl").value;
  var initialRetries = parseInt(rp.querySelector("#retries").textContent);
  if (isNaN(initialRetries)) {
    retries = 1;
  }

  if (pin === pinControl) {
    resetDisplay();

    var redirect = rp.querySelector("#redirect").textContent;
    if (redirect !== "") {
      window.open(redirect);
    }
    rp.querySelector("#errorMessageRetry").style.display = "none";

    rp.querySelector("#pinbutton").style.backgroundColor = "green";

    setTimeout(function () {
      checkDisplayComponents(rp, 1);
    }, 500);
    callPinService(true, initialRetries - retries, rp);
  } else {
    retries = retries - 1;
    if (retries > 0) {
      rp.querySelector("#errorMessageRetry").style.display = "block";
    } else {
      resetDisplay();
      rp.querySelector("#errorMessageRetry").style.display = "none";
      rp.querySelector("#pin").style.display = "none";
      rp.querySelector("#pinbutton").style.display = "none";
      checkDisplayComponents(rp, 2);
    }
    callPinService(false, initialRetries - retries, rp);
  }
}

function callPinService(success, tries, rp){
  var token = rp.querySelector("#token").textContent;
  console.log("call pin service:", success, tries, token);
  fetch(uri, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-verify": token,
    },
    body: JSON.stringify({
        success: success,
        tries: tries
    }),
  })
    .then((response) => console.log("success:", response))
    .catch((error) => console.error(error));
}

function resetDisplay(rp) {
  try {
    document.activeElement.blur();
    for (const input of document.getElementsByTagName("input"))
      input.blur();
  } catch (e) {}
  setTimeout(() => {
    try {
      rp.scroll(0, 0);
    } catch (e) {}
  }, 500);
}

function findMaxId(rp) {
  // Find all the input elements in the document
  let inputs = rp.getElementsByTagName('input');

  let max = -1;
  for (let input of inputs) {
    // Check if id starts with 'spinimage'
    if (input.id.startsWith("spinimage")) {
      // Extract the number at the end of the id
      let num = parseInt(input.id.replace("spinimage", ""), 10);
      // If id matches the pattern, update the max value
      max = Math.max(max, num);
    }
  }

  return max;
}
`;

function addScript() {
  if (document.getElementById("rpscript") !== null) {
    document.getElementById("rpscript").remove();
  }
  const script = document.createElement("script");
  script.id = "rpscript";
  script.type = "text/javascript";
  script.text = rpScript;

  document.body.appendChild(script);
}

function getElementStyle(card) {
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: card?.alignItems ? card.alignItems : "",
    textAlign: card?.alignItems ? card.alignItems : "",
    paddingLeft: card.gapLeft ? card.gapLeft + "px" : "",
    paddingRight: card.gapRight ? card.gapRight + "px" : "",
    paddingTop: card.gapTop ? card.gapTop + "px" : "",
    paddingBottom: card.gapBottom ? card.gapBottom + "px" : "",
    backgroundColor: card?.backgroundColor ? card.backgroundColor : "",
    color: card?.fontColor ? card.fontColor : "",
    fontSize: card?.fontSize ? card.fontSize + "px" : "",
    borderBottom: card?.dividerSize
      ? card.dividerSize + "px solid " + card.dividerColor
      : "",
    fontFamily: card?.bold ? "Open Sans Bold" : "Open Sans",
    lineHeight: card?.lineHeight ? card.lineHeight + "px" : "",
  };
}

export {
  templatenew,
  componentTemplate,
  verificationListRows,
  steps,
  sliderElements,
  aligmnentElements,
  colorElements,
  switchElements,
  rpScript,
  addScript,
  getElementStyle,
};
